import { render, staticRenderFns } from "./Notepad.vue?vue&type=template&id=74492a5f&"
import script from "./Notepad.vue?vue&type=script&lang=js&"
export * from "./Notepad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports